import { useState } from "react"
import { formatDateToYYYYMMDD } from "../helpers/utils"

export const useDeliveryDateSelector = () => {
  const [minDeliveryDate, setMinDeliveryDate] = useState<Date>(new Date())
  const [selectedDate, setSelectedDate] = useState(formatDateToYYYYMMDD(minDeliveryDate))
  return { selectedDate, setSelectedDate, minDeliveryDate, setMinDeliveryDate }
}